export default __webpack_public_path__ + "static/media/plan-li-users.a38df874.svg";